"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DfuseSearcher = void 0;
const flatten_1 = __importDefault(require("lodash/flatten"));
class DfuseSearcher {
    constructor({ client }) {
        this.client = client;
    }
    filterActionTraces(actions, isMatchingTrace) {
        return actions.filter(isMatchingTrace);
    }
    buildGraphQLSearchString(searchQuery, options, cursor) {
        let query = `query {
      ${options.backward ? `searchTransactionsBackward` : `searchTransactionsForward`}(query: "${searchQuery}"`;
        if (options.lowBlock)
            query += `, lowBlockNum: ${options.lowBlock}`;
        if (options.highBlock)
            query += `, highBlockNum: ${options.highBlock}`;
        query += `, limit: ${options.limit}`;
        query += `, cursor: "${cursor}") {
        results {
          cursor
          trace {
            block {
              num
              id
              timestamp
            }
            id
            matchingActions {
              account
              name
              json
              seq
              receiver
              console
              authorization {
                actor
                permission
              }
            }
          }
        }
      }
    }`;
        return query;
    }
    searchTransactions(searchQuery, actionTraceMatcher, options) {
        return __asyncGenerator(this, arguments, function* searchTransactions_1() {
            const mergedOptions = {
                highBlock: options.toBlockIncluding || undefined,
                lowBlock: options.fromBlockIncluding || undefined,
                limit: options.limit || 100,
                backward: options.backward || false,
            };
            let response;
            let cursor = ``;
            /* eslint-disable no-await-in-loop */
            do {
                try {
                    // sometimes dfuse searchTransaction gets stuck on mainnet and takes ages or never returns
                    response = yield __await(Promise.race([
                        new Promise((res, rej) => {
                            setTimeout(() => {
                                rej(new Error(`searchTransactions took too long.`));
                            }, 20 * 1e3);
                        }),
                        this.client.graphql(this.buildGraphQLSearchString(searchQuery, mergedOptions, cursor)),
                    ]));
                }
                catch (error) {
                    let { message } = error;
                    if (error.details && error.details.errors)
                        message = `${message}. ${JSON.stringify(error.details.errors)}`;
                    console.error(`dfuse: ${message}`);
                    // try again
                    continue;
                }
                if (response.errors)
                    throw new Error(response.errors.map((error) => error.message).join(`\n`));
                const { results } = response.data[options.backward ? `searchTransactionsBackward` : `searchTransactionsForward`];
                cursor = results.length > 0 ? results[results.length - 1].cursor : ``;
                const traces = results.map((obj) => obj.trace);
                const newActions = flatten_1.default(traces.map(trace => {
                    const blockNumber = Number.parseInt(trace.block.num, 10);
                    const timestamp = new Date(trace.block.timestamp);
                    const txId = trace.id;
                    return trace.matchingActions.map(actionTrace => {
                        return {
                            blockNumber,
                            timestamp,
                            account: actionTrace.account,
                            name: actionTrace.name,
                            receiver: actionTrace.receiver,
                            data: actionTrace.json,
                            console: actionTrace.console,
                            txId,
                            globalSequence: actionTrace.seq,
                            authorization: actionTrace.authorization,
                        };
                    });
                }));
                const actions = this.filterActionTraces(newActions, actionTraceMatcher);
                yield yield __await(actions);
            } while (cursor !== ``);
        });
    }
}
exports.DfuseSearcher = DfuseSearcher;
